import {
  Semanticpmpmvt7fldq2 as Semantic,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Dimensions32ju1l7z4mh as Dimension,
  timesx4ey3un7ihw1 as times,
  ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../utils/utils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { minOf33o15vox9quzb as minOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance } from '../theming/Titles.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  CountSemantic_getInstance1ocl325ub48re as CountSemantic_getInstance,
  ActionNeeded_getInstance23nk3i9c67lq9 as ActionNeeded_getInstance,
} from '../theming/appTheme.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_activity2bclxkea3doa as get_activity,
  get_threeGears3jxmg63xk9j2y as get_threeGears,
  get_hourglasssvjsonbhvye7 as get_hourglass,
  get_crossedOutHourglass2mejuvtk133nk as get_crossedOutHourglass,
  get_crowPayWarning1xs8u5vu5fskh as get_crowPayWarning,
} from '../../icons.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance } from '../screens/common/ProjectView.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  isLettere1qnx5bysxbd as isLetter,
  isDigit3mimrri4wkzop as isDigit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { lastOrNull13hbcjtcs7jv2 as lastOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { get_lastIndexld83bqhfgcdd as get_lastIndex } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Char19o2r8palgjof as Char,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  EscalationLevel_Disputed_getInstance3pwh4crkd38ie as EscalationLevel_Disputed_getInstance,
  LineItemState_KeepWorking_getInstanceieb6rws75lm1 as LineItemState_KeepWorking_getInstance,
  LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance,
} from '../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { TimerAction_CompleteLineItem_getInstance3bxbacatbrybs as TimerAction_CompleteLineItem_getInstance } from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { color1u2lxyvdop1o6 as color } from './project/work/payApps/data.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { Resources_getInstance2tvlmekcueurd as Resources_getInstance } from '../../Resources.js.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_vowels() {
  _init_properties_iconShortcuts_kt__tba6g2();
  return vowels;
}
var vowels;
function InfoBubbleSemantic$default$lambda($this$to, it) {
  return it.ab1_1;
}
var InfoBubbleSemanticClass;
function InfoBubbleSemantic() {
  if (InfoBubbleSemanticClass === VOID) {
    class $ extends Semantic() {
      static fgf() {
        InfoBubbleSemantic_instance = null;
        var $this = this.bd1('info');
        InfoBubbleSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = theme.ib0_1.ed0(4);
        var tmp_0 = HoverSemantic_getInstance();
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf(to(tmp_0, InfoBubbleSemantic$default$lambda)));
      }
      toString() {
        return 'InfoBubbleSemantic';
      }
      hashCode() {
        return -1485693042;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InfoBubbleSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'InfoBubbleSemantic');
    InfoBubbleSemanticClass = $;
  }
  return InfoBubbleSemanticClass;
}
var InfoBubbleSemantic_instance;
function InfoBubbleSemantic_getInstance() {
  if (InfoBubbleSemantic_instance === VOID)
    InfoBubbleSemantic().fgf();
  return InfoBubbleSemantic_instance;
}
function infoBubble(_this__u8e3s4, popover, setup) {
  popover = popover === VOID ? Companion_getInstance().acr_1 : popover;
  _init_properties_iconShortcuts_kt__tba6g2();
  // Inline function 'com.crowpay.views.components.infoBubbleButton' call
  var tmp = _this__u8e3s4.hbb(InfoBubbleSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (MenuButton())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.yc3_1 = false;
  view.bc4(popover);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (IconView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.ebu('Additional Information');
  view_0.qbt(resize(Companion_getInstance_0().bch_1, get_rem(1)));
  view.fbb(p_0, view_0);
  view.ec4(($this$opensMenu) => {
    var tmp = sizeConstraints($this$opensMenu, VOID, minOf(new (Dimension())(get_rem(25)), new (Dimension())(times(AppState_getInstance().mbi().f2().ebi_1, 0.8))).wb1_1);
    // Inline function 'com.crowpay.views.theming.body' call
    var setup_0 = setup;
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$opensMenu.pc());
    var tmp0_elvis_lhs = $this$opensMenu.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
    $this$opensMenu.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    setup_0(view);
    $this$opensMenu.fbb(p, view);
    $this$opensMenu.jbb(tmp, view);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function infoBubble_0(_this__u8e3s4, message) {
  _init_properties_iconShortcuts_kt__tba6g2();
  var tmp = Companion_getInstance().acr_1;
  return infoBubble(_this__u8e3s4, tmp, ($this$infoBubble) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = message;
    var tmp = $this$infoBubble.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = value;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  });
}
function concernsLegendInfoBubble(_this__u8e3s4, popover) {
  popover = popover === VOID ? Companion_getInstance().ycq_1 : popover;
  _init_properties_iconShortcuts_kt__tba6g2();
  // Inline function 'com.crowpay.views.components.infoBubbleButton' call
  var tmp = _this__u8e3s4.hbb(InfoBubbleSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (MenuButton())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.yc3_1 = false;
  view.bc4(popover);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (IconView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.ebu('Additional Information');
  view_0.qbt(resize(Companion_getInstance_0().bch_1, get_rem(1)));
  view.fbb(p_0, view_0);
  view.ec4(concernsLegendInfoBubble$lambda);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function countBubble(_this__u8e3s4, limit, count) {
  limit = limit === VOID ? 9 : limit;
  _init_properties_iconShortcuts_kt__tba6g2();
  var tmp0_width = get_rem(1);
  var tmp = _this__u8e3s4.ibb(sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, 1.0, tmp0_width), _this__u8e3s4.hbb(CountSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp_0 = get_centered(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    // Inline function 'kotlin.takeUnless' call
    var this_1 = count($this$reactiveScope);
    var tmp;
    if (!(this_1 > limit)) {
      tmp = this_1;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
    var tmp$ret$3 = tmp1_elvis_lhs == null ? '' + limit + '+' : tmp1_elvis_lhs;
    this_0.set(tmp$ret$3);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function unreadIconWhen(_this__u8e3s4, shown) {
  _init_properties_iconShortcuts_kt__tba6g2();
  // Inline function 'com.crowpay.views.components.unreadIcon' call
  _this__u8e3s4.bbb_1 = null;
  var tmp0_safe_receiver = _this__u8e3s4.cbb_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.la9();
  }
  _this__u8e3s4.cbb_1 = null;
  return Unit_instance;
}
function unreadIconVisible(_this__u8e3s4, shown) {
  _init_properties_iconShortcuts_kt__tba6g2();
  // Inline function 'com.crowpay.views.components.unreadIcon' call
  _this__u8e3s4.bbb_1 = null;
  var tmp0_safe_receiver = _this__u8e3s4.cbb_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.la9();
  }
  _this__u8e3s4.cbb_1 = null;
  return Unit_instance;
}
function actionIcon(_this__u8e3s4, size, shown) {
  size = size === VOID ? null : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  var tmp = _this__u8e3s4.hbb(ActionNeeded_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.ebu('Action Needed');
  // Inline function 'kotlin.let' call
  var it = get_activity(Companion_getInstance_0());
  var tmp_0;
  var tmp_1 = size;
  if (!((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null)) {
    tmp_0 = resize(it, size);
  } else {
    tmp_0 = resize(it, get_rem_0(0.8));
  }
  var tmp$ret$1 = tmp_0;
  view.qbt(tmp$ret$1);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionIcon_0(_this__u8e3s4, size, shown) {
  size = size === VOID ? null : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  var tmp = _this__u8e3s4.ibb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return !(shown($this$shownWhen) == null);
  }), _this__u8e3s4.hbb(ActionNeeded_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.ebu('Action Needed');
  // Inline function 'kotlin.let' call
  var it = get_activity(Companion_getInstance_0());
  var tmp_0;
  var tmp_1 = size;
  if (!((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null)) {
    tmp_0 = resize(it, size);
  } else {
    tmp_0 = resize(it, get_rem_0(0.8));
  }
  var tmp$ret$2 = tmp_0;
  view.qbt(tmp$ret$2);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function activityIcon(_this__u8e3s4, size) {
  size = size === VOID ? null : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  var tmp;
  var tmp_0 = size;
  if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
    tmp = get_rem_0(1.2);
  } else {
    tmp = size;
  }
  return actionIcon(_this__u8e3s4, tmp, ActionImportance_Important_getInstance());
}
function scopeSetIcon(_this__u8e3s4, size, setup) {
  size = size === VOID ? null : size;
  var tmp;
  if (setup === VOID) {
    tmp = scopeSetIcon$lambda;
  } else {
    tmp = setup;
  }
  setup = tmp;
  _init_properties_iconShortcuts_kt__tba6g2();
  var tmp_0 = colored(_this__u8e3s4, AppColors_getInstance().dfz_1.xg9_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  setup(view);
  // Inline function 'kotlin.let' call
  var it = get_threeGears(Companion_getInstance_0());
  var tmp_1;
  var tmp_2 = size;
  if (!((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null)) {
    tmp_1 = resize(it, size);
  } else {
    tmp_1 = it;
  }
  var tmp$ret$1 = tmp_1;
  view.qbt(tmp$ret$1);
  view.ebu('Worked Together');
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp_0, view);
}
function visibleWhen(_this__u8e3s4, condition) {
  _init_properties_iconShortcuts_kt__tba6g2();
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.bbb_1;
  var tmp = _this__u8e3s4;
  tmp.bbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    _this__u8e3s4.xb8(false);
    var tmp = KMutableProperty0();
    var tmp_0 = RView$_get_visible_$ref_5fyo75(_this__u8e3s4);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('visible', 0, tmp, tmp_0, RView$_set_visible_$ref_oufi4r(_this__u8e3s4));
    var actionToCalculate = condition;
    reactiveScope(_this__u8e3s4, ($this$reactiveScope) => {
      this_0.set(actionToCalculate($this$reactiveScope));
      return Unit_instance;
    });
    return Unit_instance;
  };
  return Companion_getInstance_1();
}
function shorthand(_this__u8e3s4) {
  _init_properties_iconShortcuts_kt__tba6g2();
  // Inline function 'kotlin.text.buildString' call
  var capacity = _this__u8e3s4.length;
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().bc(capacity);
  // Inline function 'kotlin.text.filter' call
  // Inline function 'kotlin.text.filterTo' call
  var destination = StringBuilder().d1();
  var inductionVariable = 0;
  var last = charSequenceLength(_this__u8e3s4);
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = charSequenceGet(_this__u8e3s4, index);
      if (isLetter(element) || isDigit(element)) {
        destination.xb(element);
      }
    }
     while (inductionVariable < last);
  var indexedObject = destination.toString();
  var inductionVariable_0 = 0;
  var last_0 = indexedObject.length;
  while (inductionVariable_0 < last_0) {
    var idx = inductionVariable_0;
    var letter = charCodeAt(indexedObject, inductionVariable_0);
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    var tmp;
    var tmp_0 = lastOrNull(this_0);
    if (!equals(new (Char())(letter), tmp_0 == null ? null : new (Char())(tmp_0))) {
      tmp = idx === 0 || idx === get_lastIndex(_this__u8e3s4) || !get_vowels().t1(new (Char())(letter));
    } else {
      tmp = false;
    }
    if (tmp) {
      this_0.xb(letter);
    }
  }
  return this_0.toString();
}
var TimerState_Running_instance;
var TimerState_Paused_instance;
var TimerState_Cancelled_instance;
var TimerState_entriesInitialized;
function TimerState_initEntries() {
  if (TimerState_entriesInitialized)
    return Unit_instance;
  TimerState_entriesInitialized = true;
  TimerState_Running_instance = TimerState().igf('Running', 0);
  TimerState_Paused_instance = TimerState().igf('Paused', 1);
  TimerState_Cancelled_instance = TimerState().igf('Cancelled', 2);
}
var TimerStateClass;
function TimerState() {
  if (TimerStateClass === VOID) {
    class $ extends Enum() {
      static igf(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'TimerState');
    TimerStateClass = $;
  }
  return TimerStateClass;
}
var TimerSemanticClass;
function TimerSemantic() {
  if (TimerSemanticClass === VOID) {
    class $ extends Semantic() {
      static lgf(state) {
        var $this = this.bd1('tmr_' + shorthand(state.a4_1));
        $this.kgf_1 = state;
        return $this;
      }
      cd1(theme) {
        var tmp;
        switch (this.kgf_1.b4_1) {
          case 0:
            tmp = AppColors_getInstance().kfz_1.xg9_1;
            break;
          case 1:
            tmp = AppColors_getInstance().gfz_1;
            break;
          case 2:
            tmp = AppColors_getInstance().hfz_1.xg9_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, tmp);
      }
      toString() {
        return 'TimerSemantic(state=' + this.kgf_1.toString() + ')';
      }
      hashCode() {
        return this.kgf_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TimerSemantic()))
          return false;
        if (!this.kgf_1.equals(other.kgf_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'TimerSemantic');
    TimerSemanticClass = $;
  }
  return TimerSemanticClass;
}
function timerRunningIconRaw(_this__u8e3s4, state, size) {
  size = size === VOID ? get_rem(1) : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = IconView$_get_description_$ref_x7iif6(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    switch ($this$reactiveScope.baj(state).b4_1) {
      case 0:
        tmp = 'Funds Release Timer Running';
        break;
      case 1:
        tmp = 'Funds Release Paused';
        break;
      case 2:
        tmp = 'Funds Release Cancelled';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp$ret$0 = tmp;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  var tmp_1 = KMutableProperty0();
  var tmp_2 = IconView$_get_source_$ref_hlcyij(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('source', 0, tmp_1, tmp_2, IconView$_set_source_$ref_2j4ddb(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    switch ($this$reactiveScope.baj(state).b4_1) {
      case 0:
        tmp = get_hourglass(Companion_getInstance_0());
        break;
      case 1:
        tmp = get_hourglass(Companion_getInstance_0());
        break;
      case 2:
        tmp = get_crossedOutHourglass(Companion_getInstance_0());
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp$ret$2 = resize(tmp, size);
    this_1.set(tmp$ret$2);
    return Unit_instance;
  });
  dynamicTheme(view, ($this$dynamicTheme) => TimerSemantic().lgf($this$dynamicTheme.baj(state)));
  _this__u8e3s4.fbb(p, view);
  return view;
}
function timerRunningIconInner(_this__u8e3s4, item, timer, perms, size, visibility) {
  size = size === VOID ? get_rem(1) : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  var state = remember(VOID, VOID, VOID, ($this$remember) => {
    var timer_0 = $this$remember.baj(timer);
    var tmp;
    if (!(timer_0 == null) && !timer_0.u98()) {
      tmp = TimerState_Running_getInstance();
    } else {
      var tmp0_safe_receiver = $this$remember.baj(perms);
      if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n8w(), EscalationLevel_Disputed_getInstance())) {
        tmp = TimerState_Cancelled_getInstance();
      } else {
        if (!(timer_0 == null) && timer_0.u98()) {
          tmp = TimerState_Paused_getInstance();
        } else {
          tmp = null;
        }
      }
    }
    return tmp;
  });
  var tmp = visibility(_this__u8e3s4, ($this$visibility) => {
    var tmp;
    // Inline function 'kotlin.let' call
    var it = $this$visibility.baj(item);
    if (it.r6k_1.d4(LineItemState_KeepWorking_getInstance()) > 0 && it.r6k_1.d4(LineItemState_Complete_getInstance()) < 0) {
      tmp = !($this$visibility.baj(state) == null);
    } else {
      tmp = false;
    }
    return tmp;
  });
  return _this__u8e3s4.jbb(tmp, timerRunningIconRaw(_this__u8e3s4, lens(state, timerRunningIconInner$lambda), size));
}
function timerRunningIconCtx(data, _this__u8e3s4, item, size, visibility) {
  size = size === VOID ? get_rem(1) : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  var id = lens(item, timerRunningIconCtx$lambda);
  var perms = remember(VOID, VOID, VOID, ($this$remember) => {
    var id_0 = $this$remember.baj(id);
    return $this$remember.baj(data.mgf()).p3(id_0);
  });
  var timer = remember(VOID, VOID, VOID, ($this$remember) => {
    var id_0 = $this$remember.baj(id);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = $this$remember.baj(data.ngf());
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.z7t_1.equals(TimerAction_CompleteLineItem_getInstance()) && equals(element.t7t_1, id_0) && element.c7u_1 == null) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  });
  return timerRunningIconInner(_this__u8e3s4, item, timer, perms, size, visibility);
}
function timerRunningIcon(_this__u8e3s4, item, timer, perms, size) {
  size = size === VOID ? get_rem(1) : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  return timerRunningIconInner(_this__u8e3s4, item, timer, perms, size, timerRunningIcon$lambda);
}
function timerRunningIcon_0(data, _this__u8e3s4, item) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return timerRunningIconCtx(data, _this__u8e3s4, item, VOID, timerRunningIcon$lambda_0);
}
function timerRunningIconVisible(data, _this__u8e3s4, item) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return timerRunningIconCtx(data, _this__u8e3s4, item, VOID, timerRunningIconVisible$lambda);
}
function timerRunningIcon_1(data, _this__u8e3s4, item) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return timerRunningIcon_0(data, _this__u8e3s4, lens(item, timerRunningIcon$lambda_1));
}
function timerRunningIconVisible_0(data, _this__u8e3s4, item) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return timerRunningIconVisible(data, _this__u8e3s4, lens(item, timerRunningIconVisible$lambda_0));
}
var EscalationSemanticClass;
function EscalationSemantic() {
  if (EscalationSemanticClass === VOID) {
    class $ extends Semantic() {
      static qgf(level) {
        var $this = this.bd1('escl' + level.b4_1);
        $this.pgf_1 = level;
        return $this;
      }
      cd1(theme) {
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, color(this.pgf_1));
      }
      toString() {
        return 'EscalationSemantic(level=' + toString(this.pgf_1) + ')';
      }
      hashCode() {
        return this.pgf_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EscalationSemantic()))
          return false;
        if (!this.pgf_1.equals(other.pgf_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'EscalationSemantic');
    EscalationSemanticClass = $;
  }
  return EscalationSemanticClass;
}
function escalationIconInner(_this__u8e3s4, level, size, visibility) {
  size = size === VOID ? get_rem(1) : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  var tmp = visibility(_this__u8e3s4, ($this$visibility) => !($this$visibility.baj(level) == null));
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  dynamicTheme(view, ($this$dynamicTheme) => {
    var tmp0_safe_receiver = $this$dynamicTheme.baj(level);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = EscalationSemantic().qgf(tmp0_safe_receiver);
    }
    return tmp;
  });
  view.qbt(resize(get_crowPayWarning(Companion_getInstance_0()), size));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function escalationIcon(_this__u8e3s4, level, size) {
  size = size === VOID ? get_rem(1) : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  return escalationIconInner(_this__u8e3s4, level, size, escalationIcon$lambda);
}
function escalationIconVisible(_this__u8e3s4, level, size) {
  size = size === VOID ? get_rem(1) : size;
  _init_properties_iconShortcuts_kt__tba6g2();
  return escalationIconInner(_this__u8e3s4, level, size, escalationIconVisible$lambda);
}
function concernsLegendInfoBubble$lambda($this$opensMenu) {
  _init_properties_iconShortcuts_kt__tba6g2();
  $this$opensMenu.eba(get_px(1));
  var tmp = sizeConstraints($this$opensMenu, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(48));
  // Inline function 'com.lightningkite.kiteui.views.direct.image' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (ImageView())($this$opensMenu);
  this_0.pda(ImageScaleType_Fit_getInstance());
  this_0.oda(Resources_getInstance().zf8_1);
  this_0.zba();
  $this$opensMenu.jbb(tmp, this_0);
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function scopeSetIcon$lambda(_this__u8e3s4) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return Unit_instance;
}
function RView$_get_visible_$ref_5fyo75(p0) {
  return () => p0.yb8();
}
function RView$_set_visible_$ref_oufi4r(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_description_$ref_x7iif6(p0) {
  return () => p0.pbt_1;
}
function IconView$_set_description_$ref_rpvc1e(p0) {
  return (_this__u8e3s4) => {
    p0.ebu(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_source_$ref_hlcyij(p0) {
  return () => p0.obt_1;
}
function IconView$_set_source_$ref_2j4ddb(p0) {
  return (_this__u8e3s4) => {
    p0.qbt(_this__u8e3s4);
    return Unit_instance;
  };
}
function timerRunningIconInner$lambda(it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return it == null ? TimerState_Paused_getInstance() : it;
}
function timerRunningIconCtx$lambda(it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return it.g6k_1;
}
function timerRunningIcon$lambda($this$timerRunningIconInner, it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return shownWhen($this$timerRunningIconInner, VOID, it);
}
function timerRunningIcon$lambda_0($this$timerRunningIconCtx, it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return shownWhen($this$timerRunningIconCtx, VOID, it);
}
function timerRunningIconVisible$lambda($this$timerRunningIconCtx, it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return visibleWhen($this$timerRunningIconCtx, it);
}
function timerRunningIcon$lambda_1(it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return it.hf9_1;
}
function timerRunningIconVisible$lambda_0(it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return it.hf9_1;
}
function escalationIcon$lambda($this$escalationIconInner, it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return shownWhen($this$escalationIconInner, VOID, it);
}
function escalationIconVisible$lambda($this$escalationIconInner, it) {
  _init_properties_iconShortcuts_kt__tba6g2();
  return visibleWhen($this$escalationIconInner, it);
}
function TimerState_Running_getInstance() {
  TimerState_initEntries();
  return TimerState_Running_instance;
}
function TimerState_Paused_getInstance() {
  TimerState_initEntries();
  return TimerState_Paused_instance;
}
function TimerState_Cancelled_getInstance() {
  TimerState_initEntries();
  return TimerState_Cancelled_instance;
}
var properties_initialized_iconShortcuts_kt_aqyy4k;
function _init_properties_iconShortcuts_kt__tba6g2() {
  if (!properties_initialized_iconShortcuts_kt_aqyy4k) {
    properties_initialized_iconShortcuts_kt_aqyy4k = true;
    vowels = setOf([new (Char())(_Char___init__impl__6a9atx(97)), new (Char())(_Char___init__impl__6a9atx(101)), new (Char())(_Char___init__impl__6a9atx(105)), new (Char())(_Char___init__impl__6a9atx(111)), new (Char())(_Char___init__impl__6a9atx(117)), new (Char())(_Char___init__impl__6a9atx(121))]);
  }
}
//region block: exports
export {
  actionIcon_0 as actionIcon360epyywhabwj,
  activityIcon as activityIcon1ob72qc2woiai,
  concernsLegendInfoBubble as concernsLegendInfoBubble92oj457wdret,
  countBubble as countBubbleqc8faq0macxu,
  escalationIconVisible as escalationIconVisiblevpqputebznaz,
  escalationIcon as escalationIconmtio0lqe8r8o,
  infoBubble_0 as infoBubblebw7xb14ivkdr,
  scopeSetIcon as scopeSetIcon1d64me82i5zfn,
  shorthand as shorthand368inlh8kflfb,
  timerRunningIconRaw as timerRunningIconRawxi2umccveawo,
  timerRunningIconVisible_0 as timerRunningIconVisible3suc918cgfqrp,
  timerRunningIcon_1 as timerRunningIcon3mra8cwh7awq2,
  timerRunningIcon as timerRunningIcon2ywhhe1si52sc,
  unreadIconVisible as unreadIconVisibley9o01zmxr3gz,
  unreadIconWhen as unreadIconWhen1430ixd91bo9h,
  TimerState_Cancelled_getInstance as TimerState_Cancelled_getInstance1atp9q6dwcp0z,
  TimerState_Paused_getInstance as TimerState_Paused_getInstance1wqc2dmfswf7h,
  TimerState_Running_getInstance as TimerState_Running_getInstance2chni4wrq2yl4,
};
//endregion

//# sourceMappingURL=iconShortcuts.mjs.map
